<!-- zys -->
<template>
  <div>
      <p class="tips_bottom">Setelah peninjauan data, staf akan menghubungi Anda.</p>
  </div>
</template>

<script>
export default {
  name:'' ,
  components: {},

  data () {
    return {
    };
  },

 async created(){ },

  computed: {},

  mounted(){

  },

  methods: {}
}

</script>
<style lang='less' scoped>
  .tips_bottom{
      text-align: center;
      color: #999;
      font-size: 14px;
      margin: 15px 0; 
  }
</style>


// WEBPACK FOOTER //
// src/components/bootomTip.vue